import {
  boolean,
  forward,
  number,
  object,
  partialCheck,
  pipe,
  string,
  type InferOutput
} from 'valibot'

import { VALIDATION_MESSAGES } from '@/constants/common/validation.constants'

/**
 * 運行実績詳細のステータス更新のフォームスキーマ
 */
export const tourDetailUpdateStatusFormValueSchema = pipe(
  object({
    tenantKey: string(),
    tourId: number(),
    /** 差し戻し理由 */
    comment: string(),
    /** 差し戻しかどうか */
    isReject: boolean()
  }),
  forward(
    partialCheck(
      [['isReject'], ['comment']],
      ({ isReject, comment }) => (isReject ? comment.length > 0 : true),
      VALIDATION_MESSAGES.REQUIRED_ITEM
    ),
    ['comment']
  )
)

/**
 * 運行実績詳細のステータス更新のフォーム値
 */
export type tourDetailUpdateStatusFormValue = InferOutput<
  typeof tourDetailUpdateStatusFormValueSchema
>
